import { Injectable } from '@angular/core';
import { IComponentDetails } from '../interfaces/component-details.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisableComponentService {

  private disableComponentSource = new BehaviorSubject<IComponentDetails | null>(null);
  componentToBeDisabled$ = this.disableComponentSource.asObservable();

  constructor() {  }

  disableComponent(componentToBeDisabled: IComponentDetails) {
    this.disableComponentSource.next(componentToBeDisabled);
  }
}
